const SubmissionStatuses = {
  COMPLETED: 'COMPLETED',
  RECEIVED: 'RECEIVED'
};

export default SubmissionStatuses;
